import { Box, Paper, Skeleton } from '@mui/material';
import NotFound from '../../../../components/notfound/NotFound';
import MarketMoneyFlowTable from './MarketMoneyFlowTable';
const MarketMoneyFlow = ({ tableData, isLoading }) => {

  return (
    <Paper sx={{ height: 400 }}>
      {isLoading ? <Skeleton variant='rounded' height={"100%"} /> :
        tableData.data.length < 1 ? (
          <Box sx={{ height: "100%" }}>
            <NotFound />
          </Box>
        ) : (
          <MarketMoneyFlowTable tableData={tableData} />
        )}
    </Paper>
  );
}

export default MarketMoneyFlow